import {
  TravelEU,
  TravelWorld,
  PrivateGP,
  DentOptCash,
  DentOptCashPlus,
  EAPEssential,
  EAPPremier,
  TreatmentNHS,
  Treatment,
  StandardOP,
  FullOP,
  EnhancedOP,
  MentalHealth,
  Therapies,
  ExtendedCover,
  Diagnostics
} from "./SMEModules";

export const travelOrEapModules = [
  TravelEU,
  TravelWorld,
  EAPEssential,
  EAPPremier
];

export const nonClaimsModules = [EAPEssential, EAPPremier];

export const nonFastTrackModules = [
  EAPPremier,
  DentOptCash,
  TravelEU,
  PrivateGP,
  TravelWorld,
  EAPEssential
];

export const allSMEModules = [
  Treatment,
  TreatmentNHS,
  StandardOP,
  FullOP,
  EnhancedOP,
  MentalHealth,
  Therapies,
  ExtendedCover,
  PrivateGP,
  DentOptCash,
  DentOptCashPlus,
  TravelEU,
  TravelWorld,
  EAPEssential,
  EAPPremier,
  Diagnostics
];

export const nonHowToClaimsModules = [
  EAPEssential,
  EAPPremier,
  PrivateGP,
  DentOptCash
];

export const travelModules = [TravelEU, TravelWorld];
